import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db13eb58"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_5hxyaa5b57h6kqtn5hqvbk3bcu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports